// removed by extract-text-webpack-plugin
module.exports = {"articleTeamHeader":"articles_articleTeamHeader_9kada","left":"articles_left_1VWdU","right":"articles_right_2NmYB","articlePostData":"articles_articlePostData_1S940","articleBody":"articles_articleBody_3rvcK","articleImage":"articles_articleImage_3wsI6","articleText":"articles_articleText_3l8_A","videoWrapper":"articles_videoWrapper_DkK02"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Articles/articles.css
// module id = 58
// module chunks = 0